import React from 'react'
import { captureError } from 'app/utils/errorMonitoring'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null, reference: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, errorInfo) {
    const correlationId =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `ui-${Date.now()}`
    const eventId = captureError(error, {
      componentStack: errorInfo.componentStack,
      correlationId,
    })
    this.setState({ reference: eventId || correlationId })
  }

  render() {
    if (!this.state.error) return this.props.children

    return (
      <main className="min-h-screen flex items-center justify-center bg-gray-50 px-6">
        <div className="max-w-md rounded-2xl bg-white p-8 text-center shadow-lg">
          <h1 className="text-xl font-semibold text-black-100">Something went wrong</h1>
          <p className="mt-3 text-sm text-gray-600">
            Please reload the page and try again. If the problem continues, contact support.
          </p>
          {this.state.reference && (
            <p className="mt-3 text-xs text-gray-500">Reference: {this.state.reference}</p>
          )}
          <button
            type="button"
            className="mt-6 rounded-lg bg-blue-100 px-5 py-3 text-sm font-semibold text-white"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      </main>
    )
  }
}
